<template>
  <el-menu
    :default-active="activeLink"
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    @select="handleSelect">
    
    <el-menu-item index="kata-pengantar">
      <span style="font-size: 16px;">Kata Pengantar</span>
    </el-menu-item>
    <el-menu-item index="petunjuk-penggunaan">
      <span style="font-size: 16px;">Petunjuk Penggunaan</span>
    </el-menu-item>
    <el-submenu index="pendahuluan">
      <template slot="title">
        <span style="font-size: 16px;">Pendahuluan</span>
      </template>
      <el-menu-item v-for="(i) in daftar_pendahuluan" :key="i" :index="'pendahuluan=id:'+i">{{data_sub['pendahuluan'][i]['judul']}}</el-menu-item>
      <el-menu-item v-if="role == 'admin'" index="pendahuluan=id:tambah"><i class="el-icon-plus"></i>Tambah</el-menu-item>
    </el-submenu>
    <el-submenu index="4">
      <template slot="title">
        <span style="font-size: 16px;">Kegiatan Belajar 1</span>
      </template>
      <el-menu-item v-for="(i) in daftar_materi1" :key="i" :index="'materi1=id:'+i">{{data_sub['materi1'][i]['judul']}}</el-menu-item>
      <el-menu-item v-if="role == 'admin'" index="materi1=id:tambah"><i class="el-icon-plus"></i>Tambah</el-menu-item>
    </el-submenu>
    <el-menu-item index="evaluasi1">
      <span style="font-size: 16px;">Evaluasi 1</span>
    </el-menu-item>
    
    <el-submenu index="6">
      <template slot="title">
        <span style="font-size: 16px;">Kegiatan Belajar 2</span>
      </template>
      <el-menu-item v-for="(i) in daftar_materi2" :key="i" :index="'materi2=id:'+i">{{data_sub['materi2'][i]['judul']}}</el-menu-item>
      <el-menu-item v-if="role == 'admin'" index="materi2=id:tambah"><i class="el-icon-plus"></i>Tambah</el-menu-item>
    </el-submenu>
    <el-menu-item index="evaluasi2">
      <span style="font-size: 16px;">Evaluasi 2</span>
    </el-menu-item>

    <el-menu-item index="glosarium">
      <span style="font-size: 16px;">Glosarium</span>
    </el-menu-item>
    <el-menu-item index="daftar-pustaka">
      <span style="font-size: 16px;">Daftar Pustaka</span>
    </el-menu-item>

  </el-menu>
</template>

<script>
import { database } from '../firebase'

export default {
  data() {
    return {
      data_sub: {},
      daftar_pendahuluan: [],
      daftar_materi1: [],
      daftar_materi2: [],
      role: this.$store.state.user.displayName
    }
  },
  watch: {
    $route(to) {
      this.activeLink = to.path
    }
  },
  methods: {
    handleOpen: function () {
      
    },
    handleClose: function () {

    },
    handleSelect: function (index) {
      let i = index.split("=")
      
      if (i.length > 1) {
        var param = {}
        for (var j=1; j<i.length; j++) {
          var k = i[j].split(':')
          param[k[0]] = k[1]
        }
        this.$router.push({
          name: i[0],
          params: param
        })
      } else {
        this.$router.push({
          name: i[0],
        })
      }

    }
  },
  computed: {
    activeLink: {
      get() {
        var name = ''
        name = name + this.$route.name
        if (this.$route.params) {
          for (var i in this.$route.params) {
            name = name + '=' + i + ':' + this.$route.params[i]
          }
        }
        return name
      },
      set() {

      }
    }
  },
  mounted() {
    let modulRef = database.ref('menu')
    modulRef.on('value', (snapshot) => {
      this.data_sub = snapshot.val()
      if (this.data_sub['pendahuluan']['daftar']) {
        this.daftar_pendahuluan = this.data_sub['pendahuluan']['daftar'].split(',')
      }
      if (this.data_sub['materi1']['daftar']) {
        this.daftar_materi1 = this.data_sub['materi1']['daftar'].split(',')
      }
      if (this.data_sub['materi2']['daftar']) {
        this.daftar_materi2 = this.data_sub['materi2']['daftar'].split(',')
      }
    })
  }
}
</script>

